import {combineReducers} from 'redux'
import app from './app'
import orders from './orders'
import product from './product'

export default combineReducers({
  app,
  orders,
  product,
})
